
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { X, Heart, Calendar } from "lucide-react";
import { useScrollDetection } from "@/hooks/useScrollDetection";

const StickyCTABar = () => {
  const [isDismissed, setIsDismissed] = useState(false);
  const { isTriggered: showFromScroll } = useScrollDetection({ threshold: 20 });

  const handleDismiss = () => {
    setIsDismissed(true);
  };

  if (!showFromScroll || isDismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white text-white shadow-2xl border-t border-gray-200 animate-slide-in">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-center space-x-3 flex-1">
            <Button 
              asChild
              size="sm"
              className="bg-juv-soft-blush hover:bg-juv-rose-clay text-juv-deep-chestnut text-sm rounded-full px-6 py-2"
            >
              <Link to="/locations">Locations</Link>
            </Button>
            
            <Button 
              asChild
              size="sm"
              className="bg-juv-rose-clay hover:bg-juv-terracotta text-white text-sm rounded-full px-6 py-2 flex items-center gap-2"
            >
              <Link to="/quiz">
                <Heart className="w-4 h-4" />
                Take Quiz
              </Link>
            </Button>
            
            <Button 
              asChild
              size="sm"
              className="bg-juv-terracotta hover:bg-juv-deep-chestnut text-white text-sm rounded-full px-6 py-2 flex items-center gap-2"
            >
              <Link to="/book-appointment">
                <Calendar className="w-4 h-4" />
                Book Now
              </Link>
            </Button>
          </div>
          
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-600 transition-colors ml-3"
            aria-label="Dismiss"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyCTABar;
